module.exports = __webpack_public_path__ + "static/media/Nawaf Kalby.82ddefbf.jpg";